import SubjectCloud from '../components/SubjectCloud'
import Header from '../components/Header';
import Footer from '../components/Footer';

/**
 * Subjects Page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Subjects = () => {
  return (
    <div className="page-wrap">
      <Header/>
      <div className="subjects-page">
        <SubjectCloud/>
      </div>
      <Footer/>
    </div>
  )
}

export default Subjects
